import pageAuthCondition from './PageAuthCondition'

export default {
    pageAuthCondition
}
